import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityContentBlockService} from '../../../shared/services/university-content-block.service';
import {UniversityService} from '../../../shared/services/university.service';
import {environment} from '../../../../environments/environment';
import {UtilsService} from '../../../shared/services/utils.service';

interface OverviewEditorBlock {
    type: 'content' | 'table';
    value: string;
}

@Component({
    selector: 'app-university-content-block',
    templateUrl: './university-content-block.component.html',
    styleUrls: ['./university-content-block.component.scss']
})
export class UniversityContentBlockComponent implements OnInit {
    public icon: any;
    public title: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    public blockType: string;
    public blockLabel: string;
    blocks: any = [];
    submitting: any = false;
    university: any;
    editorBlocks: OverviewEditorBlock[] = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    iconOptions = [
        'briefcase', 'globe', 'heart', 'target', 'award', 'graduation-cap',
        'wallet', 'users', 'trending-up', 'book-open'
    ];

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityContentBlockService: UniversityContentBlockService,
                private universityService: UniversityService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.blockType = this.activatedRoute.snapshot.data['blockType'];
        this.blockLabel = this.activatedRoute.snapshot.data['blockLabel'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.get();
            }
        });
    }

    get() {
        this.universityContentBlockService.getByAdmin(this.universityId, {type: this.blockType}).subscribe(data => {
            this.blocks = (data && data.length > 0) ? data : [];
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    addDetail() {
        const description = UtilsService.joinEditorBlocks(this.editorBlocks);
        const params = {
            type: this.blockType,
            icon: this.icon ? this.icon : '',
            title: this.title ? this.title : '',
            description: description ? UtilsService.encodeHtml(description) : '',
            table_html: '',
            sort_order: this.blocks ? this.blocks.length : 0
        };
        this.submitting = true;
        this.universityContentBlockService.createByAdmin(this.universityId, params).subscribe(data => {
            this.submitting = false;
            this.icon = undefined;
            this.title = undefined;
            this.editorBlocks = [{type: 'content', value: ''}];
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    delete(id) {
        this.universityContentBlockService.deleteByAdmin(this.universityId, id).subscribe(data => {
            this.get();
        });
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
